import { TOW } from "../../../app-consts/appConstants";
import { ServiceDetails } from "../../../types/ServiceDetails";

export const getTowServiceDetails = (serviceDetails: ServiceDetails) =>
  serviceDetails.serviceDetails.find((service) => service.serviceType === TOW);
